// Polyfills
import "core-js/modules/esnext.string.match-all";
import "react-app-polyfill/ie11";

// import ReactGA from 'react-ga';
import { createRoot } from "react-dom/client";
import ProjectRouter from "./ProjectRouter";
import "@radix-ui/themes/styles.css";
import "./styles/bij-energy-radix-overrides.css";

// ReactGA.initialize('UA-127419275-4');
const container = document.getElementById("root");
const root = createRoot(container);
root.render(<ProjectRouter />);
